import { render } from "./LeadManagementInformation.vue?vue&type=template&id=056ac1a1&scoped=true"
import script from "./LeadManagementInformation.vue?vue&type=script&lang=js"
export * from "./LeadManagementInformation.vue?vue&type=script&lang=js"

import "./LeadManagementInformation.vue?vue&type=style&index=0&id=056ac1a1&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-056ac1a1"]])

export default __exports__